import { atom } from "jotai";

/**
 * Controls the visibility of the "store is closed" bottom-sheet, shown when a
 * customer tries to add an item to the bag while the store is not open.
 * Driven by useStoreClosedGuard and rendered globally by StoreClosedModal.
 */
export const storeClosedModalAtom = atom(false);

export default storeClosedModalAtom;
